var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 5.5,
    stroke: "#D1D5DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8737 9.33301H20.1276C21.5303 9.33301 22.6673 10.4701 22.6673 11.8727V20.1267C22.6673 21.5293 21.5303 22.6663 20.1276 22.6663H11.8737C10.471 22.6663 9.33398 21.5293 9.33398 20.1267V11.8727C9.33398 10.4701 10.471 9.33301 11.8737 9.33301ZM19.4927 16.7933C19.7557 16.7933 19.9689 16.5801 19.9689 16.3171V14.387C19.9655 14.1254 19.7543 13.9142 19.4927 13.9108H17.588C17.325 13.9108 17.1118 14.124 17.1118 14.387C17.1118 14.65 17.325 14.8632 17.588 14.8632H18.153L15.8927 17.1235L14.6229 15.8536C14.2859 15.5178 13.7408 15.5178 13.4038 15.8536L11.7721 17.4854C11.5864 17.6713 11.5864 17.9725 11.7721 18.1584C11.8609 18.2483 11.9822 18.2987 12.1086 18.2981C12.2351 18.2994 12.3567 18.249 12.4451 18.1584L14.0387 16.6346L15.3086 17.9044C15.6456 18.2402 16.1907 18.2402 16.5276 17.9044L19.0165 15.3965V16.3171C19.0165 16.5801 19.2297 16.7933 19.4927 16.7933Z",
    fill: "#D1D5DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.de721a8ad6745e7f976d3f63b8f72a4f.svg";
export { ForwardRef as ReactComponent };